import React from 'react';
import { suggestionAction } from './productSignals';
import { formatCurrency } from '../../../utils/Utils';

export default function SuggestionAction({ row, currency = '' }) {
  const a = suggestionAction(row);
  if (!a) return <span style={{ color: '#9ca3af' }}>-</span>;
  const up = a.dir === 'up';
  return (
    <span className={up ? 'pux-sugg-up' : 'pux-sugg-down'}>
      <i className={`pi ${up ? 'pi-arrow-up' : 'pi-arrow-down'}`} style={{ fontSize: '.7rem' }} />{' '}
      {formatCurrency(a.value, currency)} ({a.delta > 0 ? '+' : ''}{a.delta.toFixed(2)})
    </span>
  );
}
